import { createFileRoute } from "@tanstack/react-router";
import FieldManagement from "@/components/field/setup/FieldManagement";

export const Route = createFileRoute("/dashboard/fields/$fieldId/setup/field")({
    component: FieldManagementPane,
});

function FieldManagementPane() {
    return <FieldManagement />;
}
